module.exports = __webpack_public_path__ + "img/gallery18.b44fa19a.jpg";